import React, { useState, useEffect } from "react";

const resultStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: 24,
    maxWidth: 400,
  },
  statusCode: {
    fontSize: 72,
    fontWeight: 600,
    lineHeight: 1,
    // color: "#4318ff",
    color: "#4319ff",
    marginBottom: 16,
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: "rgba(0, 0, 0, 0.85)",
    marginBottom: 8,
  },
  subTitle: {
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.45)",
    lineHeight: 1.6,
  },
};

function CustomResult({ status, title, subTitle }) {
  return (
    <div style={resultStyles.container}>
      <div style={resultStyles.statusCode} aria-hidden>
        {status}
      </div>
      {title != null && title !== "" && <div style={resultStyles.title}>{title}</div>}
      {subTitle != null && subTitle !== "" && <div style={resultStyles.subTitle}>{subTitle}</div>}
    </div>
  );
}

export default function PageNotFound({
  statusCode = 404,
  subTitle = "Sorry, the page you visited does not exist.",
  title,
  className,
  style,
}) {
  const [code, setCode] = useState(404);
  useEffect(() => {
    if (statusCode === 404 || statusCode === 500 || statusCode === 403) {
      setCode(statusCode);
    }
  }, [statusCode]);
  return (
    <div
      style={{ ...style }}
      className={`flex items-center justify-center w-full min-h-screen bg-gray-100 ${className ?? ""}`}
    >
      <CustomResult status={code} title={title || code} subTitle={subTitle} />
    </div>
  );
}
